var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCreatewhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.13411 9.05835C8.05078 9.05002 7.95078 9.05002 7.85911 9.05835C5.87578 8.99169 4.30078 7.36669 4.30078 5.36669C4.30078 3.32502 5.95078 1.66669 8.00078 1.66669C10.0424 1.66669 11.7008 3.32502 11.7008 5.36669C11.6924 7.36669 10.1174 8.99169 8.13411 9.05835Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1747 3.33331C15.7914 3.33331 17.0914 4.64165 17.0914 6.24998C17.0914 7.82498 15.8414 9.10831 14.2831 9.16665C14.2164 9.15831 14.1414 9.15831 14.0664 9.16665",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.96563 12.1333C1.94896 13.4833 1.94896 15.6833 3.96563 17.025C6.25729 18.5583 10.0156 18.5583 12.3073 17.025C14.324 15.675 14.324 13.475 12.3073 12.1333C10.024 10.6083 6.26562 10.6083 3.96563 12.1333Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7852 16.6667C16.3852 16.5417 16.9518 16.3 17.4185 15.9417C18.7185 14.9667 18.7185 13.3584 17.4185 12.3834C16.9602 12.0334 16.4018 11.8 15.8102 11.6667",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreatewhite);
export default __webpack_public_path__ + "static/media/createwhite.96a04e8f8365cd29f6b954d9b2382880.svg";
export { ForwardRef as ReactComponent };